/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeCatalogGetAccelerator } from "../../funcs/computeCatalogGetAccelerator.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAcceleratorRequest$inboundSchema,
};

export const tool$computeCatalogGetAccelerator: ToolDefinition<typeof args> = {
  name: "compute-catalog-get-accelerator",
  description: `Get an accelerator`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeCatalogGetAccelerator(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
